let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aJkk9")).then(() => parcelRequire('2RZ4K'));